import httpService from "../../services/http.service";
import React from "react";
import { getCMSApiRoute } from "../api.utils";

export function useGenreList({ fetchDelay = 0 } = {}) {
  const [items, setItems] = React.useState([]);
  const [hasMore, setHasMore] = React.useState(true);
  const [isLoading, setIsLoading] = React.useState(false);
  const [page, setPage] = React.useState(1);
  const limit = 10; // Number of items per page, adjust as necessary

  const loadGenre = async (page) => {
    const controller = new AbortController();
    const { signal } = controller;

    try {
      setIsLoading(true);
      if (page > 1) {
        await new Promise((resolve) => setTimeout(resolve, fetchDelay));
      }

      const response = await httpService.get(getCMSApiRoute("genre"), {
        params: {
          pageIndex: 100,
          pageNumber: 1,
        },
        signal,
      });

      if (!response.statusText === "ok") {
        throw new Error("Network response was not ok");
      }

      const { data } = response.data;

      setHasMore(data.genres?.total > page * limit);
      setItems(
        data?.result?.filter(x => x.status === 1)?.reduce(
          (acc, i) => acc.concat({ label: i.name, value: i.slug }),
          []
        )
      );
    } catch (error) {
      console.log(error);
      if (error.name === "AbortError") {
        console.log("Fetch aborted");
      } else {
        console.error("There was an error with the fetch operation:", error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    loadGenre(page);
  }, []);

  const onLoadMore = () => {
    const newOffset = page + 1;

    setPage(newOffset);
    loadGenre(newOffset);
  };

  return {
    items,
    hasMore,
    isLoading,
    onLoadMore,
  };
}
